module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    ref: "form",
    staticClass: "contact-form__input-container"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "action",
      "value": "contact"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-form__input-section"
  }, [_c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "first-name"
    },
    domProps: {
      "textContent": _vm._s('First Name')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.firstName),
      expression: "formFeilds.firstName"
    }],
    staticClass: "contact-form__input contact-form__input_small contact-form__input_small--primary",
    attrs: {
      "name": "first-name",
      "id": "first-name",
      "type": "text",
      "placeholder": "First Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formFeilds.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "last-name"
    },
    domProps: {
      "textContent": _vm._s('Last Name')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.lastName),
      expression: "formFeilds.lastName"
    }],
    staticClass: "contact-form__input contact-form__input_small contact-form__input_small contact-form__input_small--secondary",
    attrs: {
      "id": "last-name",
      "name": "last-name",
      "type": "text",
      "placeholder": "Last Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formFeilds.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "lastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "phone-number"
    },
    domProps: {
      "textContent": _vm._s('Phone Number')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.phoneNumber),
      expression: "formFeilds.phoneNumber"
    }],
    staticClass: "contact-form__input contact-form__input_big",
    attrs: {
      "id": "phone-number",
      "name": "phone-number",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.formFeilds.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "email"
    },
    domProps: {
      "textContent": _vm._s('Email')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.email),
      expression: "formFeilds.email"
    }],
    staticClass: "contact-form__input contact-form__input_big",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "placeholder": "Email Address",
      "required": ""
    },
    domProps: {
      "value": (_vm.formFeilds.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "message"
    },
    domProps: {
      "textContent": _vm._s('Message')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.message),
      expression: "formFeilds.message"
    }],
    staticClass: "contact-form__input contact-form__input_big contact-form__input__big-bottom",
    attrs: {
      "id": "message",
      "name": "message",
      "type": "text",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.formFeilds.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "g-recaptcha-response"
    },
    domProps: {
      "value": _vm.recaptchaToken
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-form__button-container"
  }, [(_vm.notValid) ? _c('p', {
    staticClass: "paragraph-01 contact-form__validity-copy",
    domProps: {
      "textContent": _vm._s(_vm.options.form_error)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('button', {
    staticClass: "contact-form__submit-btn",
    attrs: {
      "type": "submit",
      "aria-pressed": "false",
      "aria-describedby": "submit-button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('span', {
    staticClass: "contact-form__submit-btn-text"
  }, [_vm._v(_vm._s(_vm.options.submit_button_text))])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "contact-form__submitted-container"
  }, [_c('h3', {
    staticClass: "paragraph-01",
    domProps: {
      "textContent": _vm._s(_vm.options.form_submit)
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3df4f340","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactForm.vue
// module id = 302
// module chunks = 1